import { render, staticRenderFns } from "./deliveryDetailsInfo.vue?vue&type=template&id=dfea6baa&scoped=true&"
import script from "./deliveryDetailsInfo.vue?vue&type=script&lang=js&"
export * from "./deliveryDetailsInfo.vue?vue&type=script&lang=js&"
import style0 from "./deliveryDetailsInfo.vue?vue&type=style&index=0&id=dfea6baa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfea6baa",
  null
  
)

export default component.exports